import { create } from "zustand";

const initState = {
  phoneNum: "",
  otpCode: "",
  remind: 120,
};

const initStore = {
  step: 1,
  inputState: { ...initState },
  error: { ...initState },
  infinitLoading: false,
  hasLogin: false,
  hasRegistered: false,
};

export const useSignIn = create((set) => ({
  ...initStore,
  setStep: (data) =>
    set((state) => ({
      ...state,
      step: data,
    })),
  setInfinitLoading: (data) =>
    set((state) => ({
      ...state,
      infinitLoading: data,
    })),
  setState: (data) =>
    set((state) => ({
      ...state,
      inputState: {
        ...state.inputState,
        ...data,
      },
    })),
  setError: (data) =>
    set((state) => ({
      ...state,
      error: {
        ...state.error,
        ...data,
      },
    })),

  resetState: () =>
    set((state) => ({
      ...state,
      inputState: { ...initState },
    })),
  resetError: () => {
    set((state) => ({
      ...state,
      error: { ...initState },
    }));
  },
  resetSignInStore: () => set((state) => ({ ...state, ...initStore })),
  setHasLogin: () => set((state) => ({ ...state, hasLogin: true, infinitLoading: false })),
  setHasRegistered: (data) =>
    set((state) => ({
      ...state,
      hasRegistered: data,
    })),
  setSeenGuideModal: () =>
    set((state) => ({
      ...state,
      seenGuideModal: true,
    })),
}));
